/** Land Records `calcarea` is GIS area in square meters. */
export const SQ_METERS_PER_ACRE = 4046.8564224;

export function squareMetersToAcres(squareMeters) {
  const n = Number(squareMeters);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n / SQ_METERS_PER_ACRE;
}

export function formatGisAcres(squareMeters) {
  const acres = squareMetersToAcres(squareMeters);
  if (acres == null) return null;
  if (acres < 0.01) return '< 0.01';
  return acres.toFixed(2);
}

function firstNonEmpty(props, keys) {
  const p = props || {};
  for (const key of keys) {
    const v = p[key];
    if (v != null && String(v).trim() !== '') return String(v).trim();
  }
  return null;
}

/**
 * Normalize Land Records tile properties for the parcel sheet.
 */
export function deriveParcelSummary(parcel) {
  const p = (parcel && parcel.properties) ? parcel.properties : {};

  const owner = firstNonEmpty(p, ['ownername', 'owner', 'owner_name']);
  const ownerType = firstNonEmpty(p, ['ownertype']);

  const mailingStreet = firstNonEmpty(p, ['owneraddr']);
  const mailingCity = firstNonEmpty(p, ['ownercity']);
  const mailingState = firstNonEmpty(p, ['ownerstate']);
  const mailingZip = firstNonEmpty(p, ['ownerzip']);
  let mailing = null;
  if (mailingStreet || mailingCity || mailingState || mailingZip) {
    const cityState = [mailingCity, mailingState].filter(Boolean).join(', ');
    mailing = [mailingStreet, cityState, mailingZip].filter(Boolean).join(', ');
  }

  const apn = firstNonEmpty(p, ['parcelid', 'parcel_id']);
  const street = firstNonEmpty(p, ['parceladdr']);
  const city = firstNonEmpty(p, ['parcelcity']);
  const state = firstNonEmpty(p, ['parcelstate']);
  const zip = firstNonEmpty(p, ['parcelzip']);
  let address = null;
  if (street && (city || state || zip)) {
    const cityState = [city, state].filter(Boolean).join(', ');
    const line2 = [cityState, zip].filter(Boolean).join(' ');
    address = [street, line2].filter(Boolean).join(', ');
  } else if (street) {
    address = street;
  }

  const county = firstNonEmpty(p, ['countyname']);
  const gisAcresLabel = formatGisAcres(p.calcarea);
  const parcelId =
    (parcel && parcel.parcelId) ||
    firstNonEmpty(p, ['lrid', 'parcelid', 'parcel_id']) ||
    'Unknown';

  return {
    owner,
    ownerType,
    mailing,
    apn,
    address,
    county,
    gisAcresLabel,
    parcelId
  };
}
